class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '0c33ddc2';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1195.0.5';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Thu, 17 Sep 2026 19:10:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-09-17 15:09:45 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-09-17 15:09:45 Boston - 0c33ddc2 - 1195.0.5';
export default BuildTags;
